<template>
    <a-layout-footer class="footer">
        <div class="title">
            Copyright © Designed & Developed by {{ currentYear }}
        </div>
    </a-layout-footer>
</template>
<script>
export default {
    name: 'AppFooter',
    data() {
        return {
            currentYear: new Date().getFullYear()
        }
    }
}
</script>
<style scoped>
.footer {
    background: #fff;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title {
    text-align: center;
    width: 100%;
    height: 15px;
}
</style>